import { Helmet } from "react-helmet-async";
import DOMPurify from "dompurify";
import MainLayout from "@/layouts/MainLayout";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import PointedSectionBackground from "@/components/PointedSectionBackground";

const PrivacyPolicy = () => {
  const { settings } = useSiteSettings();

  const title = settings.privacy_hero_title || "Privacy Policy";
  const subtitle = settings.privacy_hero_subtitle || "How we collect, use, and protect your information";
  const content = settings.privacy_content || "";

  return (
    <MainLayout>
      <Helmet>
        <title>Privacy Policy | Rogue Skull Games</title>
        <meta
          name="description"
          content="Learn what information Rogue Skull Games collects, how it is used, and the choices you have over your personal data."
        />
        <link rel="canonical" href="https://rogueskullgames.com/privacy-policy" />
        <meta property="og:title" content="Privacy Policy | Rogue Skull Games" />
        <meta
          property="og:description"
          content="What information Rogue Skull Games collects, how it is used, and the choices you have."
        />
        <meta property="og:url" content="https://rogueskullgames.com/privacy-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <main className="min-h-screen bg-white">
        <section className="relative z-10 pt-[220px] pb-20">
          <PointedSectionBackground />
          <div className="container relative z-10 mx-auto px-4 text-center">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-dark-foreground mb-6">{title}</h1>
            <p className="text-lg text-dark-foreground/70 max-w-2xl mx-auto">{subtitle}</p>
          </div>
        </section>

        <section className="pt-32 pb-16 md:pt-36 md:pb-24">
          <div className="container mx-auto px-4 max-w-3xl">
            <div
              className="prose prose-lg max-w-none text-[hsl(0,0%,35%)]
                [&_h2]:font-heading [&_h2]:text-2xl md:[&_h2]:text-3xl [&_h2]:text-[hsl(0,0%,10%)] [&_h2]:mb-6
                [&_h3]:font-heading [&_h3]:text-xl [&_h3]:text-[hsl(0,0%,10%)] [&_h3]:mb-4
                [&_p]:mb-8 [&_p]:leading-relaxed
                [&_ul]:mb-8 [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-2
                [&_ol]:mb-8 [&_ol]:list-decimal [&_ol]:list-inside [&_ol]:space-y-2
                [&_hr]:mt-14 [&_hr]:mb-12 [&_hr]:border-[hsl(0,0%,85%)]
                [&_strong]:text-[hsl(0,0%,10%)]
                [&_a]:text-blood-red hover:[&_a]:underline"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            />
          </div>
        </section>
      </main>
    </MainLayout>
  );
};

export default PrivacyPolicy;
